import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { ReportsCardHeaderProps } from './types';

const ReportsCardHeader: FC<ReportsCardHeaderProps> = ({ title = '' }) => (
  <Typography
    sx={{ color: 'text.primary', display: 'inline-block', fontSize: '18px', fontWeight: 700, width: '50%' }}
    variant="subtitle2">
    {title}
  </Typography>
);

export default ReportsCardHeader;
